<template>
	<div class="box-register">
		<h2 v-if="$route.query['tipo-contato'] == 'C'" :style="parceiroConfigCorSecundariaCorPrimaria">Você está próximo de se tornar um parceiro do {{ capitalizeFirstLetter(parceiroConfig.nome) }}</h2>
		<h2 v-else :style="parceiroConfigCorSecundariaCorPrimaria">Entre em contato conosco</h2>
		<h3>Preencha seus dados abaixo, logo entraremos em contato</h3>

		<div class="box-forms-regiter">
			<form-fields
				:fields="fields"
				@save="completeRegister"
				@update:values="inputsValues = $event"></form-fields>
		</div>

		<div class="box-button-register">
			<button-lg
				:color="corPrimaria"
				:full="true"
				@click.native="completeRegister()"
				text="Solicitar cadastro" ></button-lg>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import globalMethods from "@/mixins/globalMethods";
import mixins from "@/mixins/mixins";

import ButtonDefault from "@/components/buttons/ButtonDefault";
import FormFields from "@/components/FormFields";
import ButtonLg from "@/components/buttons/ButtonLg";

export default {
	name: "CadastrarNovoCredor",
	
	components: { ButtonLg, FormFields, ButtonDefault },

	mixins: [globalMethods, mixins],

	data() {
		return {
			fields: [],
			identification: "",
			inputsValues: {}
		};
	},

	computed: {
		...mapState({
			showMessageModal: (estado) => estado.messageModal.show,
		})
	},

	mounted() {
		if (this.$route.query["tipo-contato"] == "C") {
			this.fields = [
				{
					variableName: "nomeContato",
					fieldType: "TextField",
					label: "Nome para contato",
					type: "text",
					cols: "12"
				},
				{
					variableName: "telefoneCel",
					fieldType: "TextFieldMask",
					label: "Celular",
					maskFormat: "(##) #####-####",
					type: "text",
					cols: "6"
				},
				{
					variableName: "email",
					fieldType: "TextField",
					label: "E-mail",
					type: "text",
					cols: "6",
				},
				{
					variableName: "razaoSocial",
					fieldType: "TextField",
					label: "Razão Social",
					type: "text",
					cols: "6",
				},
				{
					variableName: "cnpj",
					fieldType: "TextFieldMask",
					label: "CNPJ",
					type: "text",
					cols: "6",
					maskFormat: "##.###.###/####-##"
				},
				{
					variableName: "apresentacaoCredor",
					fieldType: "TextField",
					label: "Nos fale um pouco sobre sua empresa",
					type: "text",
					cols: "12",
					required: false
				},
			];
		} else {
			this.fields = [
				{
					variableName: "nomeContato",
					fieldType: "TextField",
					label: "Nome para contato",
					type: "text",
					cols: "12"
				},
				{
					variableName: "cnpj",
					fieldType: "TextFieldMask",
					label: "CPF",
					type: "text",
					cols: "12",
					maskFormat: "###.###.###-##"
				},
				{
					variableName: "telefoneCel",
					fieldType: "TextFieldMask",
					label: "Celular",
					maskFormat: "(##) #####-####",
					type: "text",
					cols: "6"
				},
				{
					variableName: "email",
					fieldType: "TextField",
					label: "E-mail",
					type: "text",
					cols: "6",
				},
				{
					variableName: "apresentacaoCredor",
					fieldType: "TextField",
					label: "Cadastre seus débitos que nós vamos buscar para você a melhor negociação. Descontos de até 90%!",
					type: "text",
					cols: "12",
					required: false
				},
			];
		}
	},

	methods: {
		...mapActions(["action_envio_contato_portal"]),

		completeRegister() {
			const { cnpj, email, telefoneCel, nomeContato, razaoSocial, apresentacaoCredor } = this.inputsValues;			

			let required = false;
			Object.entries(this.inputsValues).forEach(([key, value]) => {

				if (!this.showMessageModal && (!value || value === "")) {
					required = true;
					this.CHANGE_MESSAGE_MODAL({
						show: true,
						title: "Atenção",
						message: `O campo ${this.fields.filter((field) => field.variableName === key)[0].label} é obrigatório`,
						styleMessage: "danger"
					});
				}
			});

			if (!required) {
				if (/.+@.+\..+/.test(email) === false) {
					this.CHANGE_MESSAGE_MODAL({
						show: true,
						title: "Atenção",
						message: `Digite um e-mail válido`,
						styleMessage: "danger"
					});

				} else if (telefoneCel.length < 15) {
					this.CHANGE_MESSAGE_MODAL({
						show: true,
						title: "Atenção",
						message: `Digite um celular válido`,
						styleMessage: "danger"
					});
				} else if (
					nomeContato.trim() == "" ||
					nomeContato.trim() == undefined ||
					nomeContato.trim() == null
				) {
					this.CHANGE_MESSAGE_MODAL({
						show: true,
						title: "Atenção",
						message: `Nome para contato é um campo obrigatório`,
						styleMessage: "danger"
					});
				} else if (
					this.$route.query["tipo-contato"] == "C" &&
					(
						razaoSocial.trim() == "" ||
						razaoSocial.trim() == undefined ||
						razaoSocial.trim() == null
					)
				) {
					this.CHANGE_MESSAGE_MODAL({
						show: true,
						title: "Atenção",
						message: `Nome para contato é um campo obrigatório`,
						styleMessage: "danger"
					});
				} else if (
					cnpj.trim() == "" ||
					cnpj.trim() == undefined ||
					cnpj.trim() == null
				) {
					this.CHANGE_MESSAGE_MODAL({
						show: true,
						title: "Atenção",
						message: `Nome para contato é um campo obrigatório`,
						styleMessage: "danger"
					});
				} else {
					this.SET_LOADING(true);
					this.SET_LOADING_MESSAGE("Realizando o seu cadastro");

					let tipoContato = this.$route.query["tipo-contato"];
					if (!["C", "D"].includes(tipoContato)) {
						tipoContato = "D";
					}

					let obj = {
						emp_codigo: this.parceiroConfig.emp_codigo,
						nome: nomeContato,
						email: email,
						cpfCnpj: this.removeMaskCharacters(cnpj),
						texto: apresentacaoCredor,
						tipo_pessoa: tipoContato,
						telefone: this.removeMaskCharacters(telefoneCel),
						empresa: razaoSocial ?? "",
					};

					this.action_envio_contato_portal(obj).then(resposta => {
						this.SET_LOADING_MESSAGE("");
						this.SET_LOADING(false);
						
						if (resposta.data.retorno) {
							this.CHANGE_MESSAGE_MODAL({
								show: true,
								title: "Sucesso",
								message: "Solicitação cadastrada com sucesso!",
								styleMessage: "success"
							});
							this.$router.push({ name: "LandPage" });
						} else {
							this.CHANGE_MESSAGE_MODAL({
								show: true,
								title: "Erro",
								message: "Não foi possível cadastrar a sua solicitação",
								styleMessage: "danger"
							});
						}
					}).catch((_) => {
						this.SET_LOADING_MESSAGE("");
						this.SET_LOADING(false);
					});
				}
			}
		}
	}
};
</script>

<style scoped lang="scss">
.box-register {
	min-height: 100vh;
	display: flex;
	flex: 1;
	padding: 50px 0;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	box-sizing: border-box;
	background: #f3f5f9;
}

.box-register h2 {
	font-family: Montserrat-Bold;
	color: var(--primaryColor);
	font-size: 32px;
	text-align: center;
	@media only screen and (max-width: 990px) {
		font-size: 28px;
	}
}

.box-register h3 {
	font-family: Cabin;
	font-size: 18px;
	color: var(--grayColor);
	margin: 10px 0 30px 0;
	text-align: center;
}

.box-forms-regiter {
	width: 50vw;
	box-sizing: border-box;
	@media only screen and (max-width: 990px) {
		width: 90%;
	}
}

.box-button-register {
	width: 50vw;
	box-sizing: border-box;
	@media only screen and (max-width: 990px) {
		width: 90%;
	}
}
</style>
